import React from 'react';
import {t} from '@lingui/core/macro';

import {MonitorSectionTitle} from 'entities/monitor';
import TableBox from 'shared/ui/Box/TableBox/TableBox';
import PortCheckResultsTable from 'features/port/ui/PortIncident/PortCheckResultsTable/PortCheckResultsTable';
import IPortMonitor from 'features/port/model/PortMonitor/IPortMonitor';

import styles from './PortMonitorChecks.module.scss';

interface IPortMonitorChecksProps {
    portMonitor: IPortMonitor,
}

const PortMonitorChecks: React.FC<IPortMonitorChecksProps> = ({portMonitor}) => (
    <TableBox className={styles.section}>
        <MonitorSectionTitle title={t`Последняя проверка по локациям`}/>

        <PortCheckResultsTable
            results={portMonitor.last_results ?? []}
            emptyText={t`Проверок ещё не было`}
        />
    </TableBox>
);

export default PortMonitorChecks;
